@if (isInitializing()) {
  <fmnts-loading-indicator variant="fontawesome" size="lg" />
}
@if (showFrame()) {
  <iframe
    #tamaro
    [src]="cfg.url | bypassSecurityTrustResourceUrl"
    (load)="_onIframeLoaded(tamaro, widgetConfig())"
    (error)="_onIframeFailed()"
    [class.hidden]="isInitializing()"
  >
  </iframe>
}
